export default __webpack_public_path__ + "static/media/activeSimpleServo.cc143a67.svg";